import type { KeyPrefix } from 'i18next';

import { t } from '../../i18n-t';
import type { FormConfig } from '../types';
type RatingKeys = KeyPrefix<'ratings'>;

export const getAssessmentFormConfig = (
  taxonomyKey:
    | 'assessments'
    | 'complianceMonitoringAssessment'
    | 'internalAuditReports',
  outcomeRatingKey: RatingKeys
) => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t(`${taxonomyKey}.fields.Title`),
      columnHeader: t(`${taxonomyKey}.columns.Title`),
      allowAsConditionSource: true,
    },
    Summary: {
      fieldId: 'Summary',
      formLabel: t(`${taxonomyKey}.fields.Summary`),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    CompletedByUser: {
      fieldId: 'CompletedByUser',
      formLabel: t(`${taxonomyKey}.fields.CompletedBy`),
      columnHeader: t(`${taxonomyKey}.columns.CompletionBy`),
      allowTargetConditions: true,
      allowAsConditionSource: true,
      displayType: {
        displayType: 'users',
        multiple: false,
      },
    },
    StartDate: {
      fieldId: 'StartDate',
      formLabel: t(`${taxonomyKey}.fields.StartDate`),
      columnHeader: t(`${taxonomyKey}.columns.StartDate`),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    TargetCompletionDate: {
      fieldId: 'TargetCompletionDate',
      formLabel: t(`${taxonomyKey}.fields.TargetCompletionDate`),
      columnHeader: t(`${taxonomyKey}.columns.TargetCompletionDate`),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    ActualCompletionDate: {
      fieldId: 'ActualCompletionDate',
      formLabel: t(`${taxonomyKey}.fields.ActualCompletionDate`),
      columnHeader: t(`${taxonomyKey}.columns.CompletionDate`),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    NextTestDate: {
      fieldId: 'NextTestDate',
      formLabel: t(`${taxonomyKey}.fields.NextTestDate`),
      columnHeader: t(`${taxonomyKey}.columns.NextTestDate`),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Owners: {
      fieldId: 'Owners',
      formLabel: t(`fields.Owner`),
      columnHeader: t(`columns.owners`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
    },
    Status: {
      fieldId: 'Status',
      formLabel: t(`${taxonomyKey}.fields.Status`),
      columnHeader: t(`${taxonomyKey}.columns.Status`),
      allowAsConditionSource: true,
      displayType: {
        displayType: 'commonLookup',
        i18nKey: `${taxonomyKey}.status`,
      },
    },
    Outcome: {
      fieldId: 'Outcome',
      formLabel: t(`${taxonomyKey}.fields.Outcome`),
      columnHeader: t(`${taxonomyKey}.columns.Outcome`),
      displayType: { displayType: 'rating', ratingKey: outcomeRatingKey },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Contributors: {
      fieldId: 'Contributors',
      formLabel: t(`fields.Contributor`),
      columnHeader: t(`columns.contributors`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Viewers: {
      fieldId: 'Viewers',
      formLabel: t(`fields.Viewer`),
      columnHeader: t(`columns.viewers`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    tags: {
      fieldId: 'tags',
      formLabel: t(`fields.Tags`),
      columnHeader: t(`columns.tags`),
      displayType: {
        displayType: 'tags',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    departments: {
      fieldId: 'departments',
      formLabel: t(`fields.Departments`),
      columnHeader: t(`columns.departments`),
      displayType: {
        displayType: 'departments',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
